import React, { useEffect, useState } from "react";
import SidebarFilter from "../components/catalog/SidebarFilter";
import ProductCard from "../components/catalog/ProductCard";
import EngineBrandCard from "../components/EngineBrandCard";
import { supabase } from "../lib/supabase";

// Existing brand data mostly for "Partners" display
const engineBrands = [
  {
    name: "HIDEA",
    image: "/images/enginebrands/hidea.jpg",
    isAuthorizedDealer: true,
    isAuthorizedService: true,
  },
  {
    name: "PARSUN",
    image: "/images/enginebrands/parsun.png",
    isAuthorizedDealer: true,
    isAuthorizedService: true,
  },
  {
    name: "TOHATSU",
    image: "/images/enginebrands/tohatsu.jpg",
    isAuthorizedDealer: true,
    isAuthorizedService: false,
  },
  {
    name: "MERCURY",
    image: "/images/enginebrands/mercury.png",
    isAuthorizedDealer: true,
    isAuthorizedService: false,
  },
];

const ENGINE_CATEGORIES = ["Outboard", "Inboard", "İkinci el", "Elektrikli", "Sanal çapa"];

interface Engine {
  id: string;
  title: string;
  description: string;
  price: string;
  imageUrl: string;
  brand: string;
  category?: string;
  oldPrice?: string;
}

const EnginesPage: React.FC = () => {
  const [engines, setEngines] = useState<Engine[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchEngines = async () => {
        const { data, error } = await supabase.from('engines').select('*');
        if (error) {
            console.error(error);
            setLoading(false);
        } else {
            setEngines(data as Engine[]);
            setLoading(false);
        }
    };
    fetchEngines();
  }, []);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filteredEngines = engines.filter(engine => {
      const matchesSearch = engine.title.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesCategory = selectedCategory ? engine.category === selectedCategory : true;
      return matchesSearch && matchesCategory;
  });

  return (
    <div className="w-full bg-[#f8f9fa] text-gray-800 font-montserrat min-h-screen">
      
      {/* Breadcrumb / Title Header */}
      <div className="bg-white border-b py-4 px-6 md:px-12 mb-8">
           <div className="max-w-7xl mx-auto flex items-center text-sm text-gray-500">
               <span>Anasayfa</span> <span className="mx-2">/</span> <span className="text-gray-900 font-semibold">Deniz Motorları</span>
           </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-12">
          <div className="flex flex-col md:flex-row gap-8">
              
              {/* Sidebar */}
              <div className="w-full md:w-64 flex-shrink-0">
                  <SidebarFilter
                      title="Deniz Motorları"
                      categories={[
                          { name: "Tüm Motorlar", active: !selectedCategory, onClick: () => setSelectedCategory(null), count: engines.length },
                          ...ENGINE_CATEGORIES.map(cat => ({
                              name: cat,
                              count: engines.filter(e => e.category === cat).length,
                              active: selectedCategory === cat,
                              onClick: () => setSelectedCategory(selectedCategory === cat ? null : cat)
                          }))
                      ]}
                      onSearch={setSearchQuery}
                  />
              </div>

              {/* Main Content */}
              <div className="flex-1">
                   {/* Sort / Info Bar */}
                   <div className="bg-white p-4 rounded border mb-6 flex justify-between items-center text-sm">
                       <div>Toplan <span className="font-bold">{filteredEngines.length}</span> ürün</div>
                       <select className="border rounded p-1">
                           <option>Önerilen sıralama</option>
                           <option>Fiyata göre artan</option>
                           <option>Fiyata göre azalan</option>
                       </select>
                   </div>

                   {loading ? (
                        <div className="text-center py-20">Yükleniyor...</div>
                   ) : filteredEngines.length === 0 ? (
                        <div className="text-center py-20 bg-white rounded border">Aradığınız kriterlere uygun motor bulunamadı.</div>
                   ) : (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                            {filteredEngines.map(engine => (
                                <ProductCard
                                    key={engine.id}
                                    id={engine.id}
                                    title={engine.title}
                                    price={engine.price}
                                    image={engine.imageUrl}
                                    brand={engine.brand}
                                    linkPrefix="/urunler/motor"
                                    oldPrice={engine.oldPrice || undefined}
                                />
                            ))}
                        </div>
                   )}
              </div>

          </div>
      </div>

      <div className="bg-white py-12 border-t">
          <div className="max-w-7xl mx-auto px-6">
              <h2 className="text-3xl font-bold text-center mb-8 font-montserrat text-[#002744]">İş Ortaklarımız</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                 {engineBrands.map((brand) => (
                   <EngineBrandCard key={brand.name} {...brand} />
                 ))}
              </div>
          </div>
      </div>
    </div>
  );
};

export default EnginesPage;
